import { useOutletContext } from "react-router-dom";

import OrganizationSettingsVendorsView from "../../views/OrganizationSettingsView/OrganizationSettingsVendorsView";

export default function OrganizationSettingsVendors() {
	const { organization } = useOutletContext();

	return <OrganizationSettingsVendorsView organization={organization} />;
}
